
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/atencio/subtitulacio",
      function () {
        return require("private-next-pages/corporatiu/atencio/subtitulacio/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/atencio/subtitulacio"])
      });
    }
  